import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// Import TinyMCE Rich Text Editor so that no API key is required
// Also, additional skins/ folder is copied to public/static/js/
import './app/tinymce.imports';
import App from './App';
import {persistor, store} from './app/store';
import {Provider} from 'react-redux';
import {BrowserRouter as Router, Route, Switch, RouteComponentProps} from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import {DJANGO_LOGIN_URL, DJANGO_LOGOUT_URL, REACT_LOGIN_URL, REACT_LOGOUT_URL, baseURL} from "./app/settings";
import {PersistGate} from 'redux-persist/integration/react';


const Login = (props: RouteComponentProps) => {
    const params = new URLSearchParams(props.location.search);
    if (params.get('next') === null) {
        const nextURL = baseURL + props.location.pathname + props.location.search;
        params.set('next', nextURL);
    }
    window.location.href = DJANGO_LOGIN_URL + `?${params.toString()}`;
    return null;
}

ReactDOM.render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Router basename={baseURL}>
                    <Switch>
                        <Route path={REACT_LOGIN_URL} component={Login}/>
                        <Route path={REACT_LOGOUT_URL} component={(props: RouteComponentProps) => {
                            window.location.href = DJANGO_LOGOUT_URL + props.location.search;
                            return null;
                        }}/>
                        <Route path='/' component={App}/>
                    </Switch>
                </Router>
            </PersistGate>
        </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
